import Button from "common/Buttons/Button.tsx";
import FilterOutlined from "@ant-design/icons/FilterOutlined";
import FiltersCounter from "common/Filters/common/FiltersCounter.tsx";
import React from "react";
import styled from "styled-components";
import { FiltersSelector, LanguageNameSpaces } from "@shared/types";
import { useSelector } from "react-redux";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface FiltersButtonProps {
  onClick: () => void;
  selectors: FiltersSelector;
}

const FiltersButton = ({ onClick, selectors }: FiltersButtonProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const numActiveFilters = useSelector(selectors.selectNumActiveFilters);

  return (
    <FiltersButtonWrapper>
      <Button onClick={onClick}>
        <FilterOutlined />
        {t("filters.common.title")}
      </Button>
      <FiltersCounter numActiveFilters={numActiveFilters} />
    </FiltersButtonWrapper>
  );
};

export default FiltersButton;

const FiltersButtonWrapper = styled.div`
  position: relative;
`;
